import { useContext } from 'react'

import { ArrowLeft01Icon, ArrowRight01Icon } from '@hugeicons/react'
import _ from 'lodash'
import {
  ScrollMenu as ReactHorizontalScrollingMenu,
  VisibilityContext
} from 'react-horizontal-scrolling-menu'

import usePreventBodyScroll from '@/shared/hooks/usePreventBodyScroll'

import styles from './styles.module.scss'

export const ScrollMenu = ({ className = '', children }) => {
  const { disableScroll, enableScroll } = usePreventBodyScroll()

  return (
    <div
      className={styles.DisableScrollBar}
      onMouseEnter={disableScroll}
      onMouseLeave={enableScroll}
    >
      <ReactHorizontalScrollingMenu
        LeftArrow={LeftArrow}
        RightArrow={RightArrow}
        onWheel={onWheel}
        scrollContainerClassName={className}
      >
        {children}
      </ReactHorizontalScrollingMenu>
    </div>
  )
}

const LeftArrow = () => {
  const visibility = useContext(VisibilityContext)
  const isVisible = visibility.useIsVisible('first', false)

  return (
    <Arrow
      disabled={isVisible}
      onClick={() => visibility.scrollPrev()}
      className="ml-2"
    >
      <ArrowLeft01Icon variant="duotone" size={20} />
    </Arrow>
  )
}

const RightArrow = () => {
  const visibility = useContext(VisibilityContext)
  const isVisible = visibility.useIsVisible('last', false)

  return (
    <Arrow
      disabled={isVisible}
      onClick={() => visibility.scrollNext()}
      className="ml-2"
    >
      <ArrowRight01Icon variant="duotone" size={20} />
    </Arrow>
  )
}

const Arrow = ({ children, disabled, onClick, className = '' }) => (
  <button
    disabled={disabled}
    onClick={onClick}
    className={`flex items-center justify-center w-8 h-full shrink-0 rounded-[0.625rem] border-0 bg-transparent text-gray-700 hover:bg-gray-100 disabled:opacity-30 cursor-pointer ${className}`}
  >
    {children}
  </button>
)

const onWheel = (apiObj, ev) => {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15

  if (isThouchpad) {
    ev.stopPropagation()
    return
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext()
  } else {
    apiObj.scrollPrev()
  }
}
